import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { NotificationsResponse } from './types';

export async function getMemberNotifications(memberId: string) {
  const url = `/web/studio/users/${memberId}/notifications`;

  const response = await api.executeGetRequest<ObjectResponse<NotificationsResponse>>(url);

  return response.data;
}
